<template>
    <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
        <el-col :span="13">
            <el-row>
                <el-col>
                    <div class="spreadsheet-header-title">
                        {{ title }}
                    </div>
                    <div class="spreadsheet-header-filter-info" v-if="visibleOptions.isFilterVisible">
                        <span class="spreadsheet-header-filter-info_black">
                            Поиск по:
                        </span>
                        <span class="spreadsheet-header-filter-info_gray">
                            {{ filterTitle }}
                        </span>
                    </div>
                </el-col>
            </el-row>
            <el-row v-if="visibleOptions.isFilterVisible">
                <el-col>
                    <span class="spreadsheet-header-filter-info_black">
                        Всего найдено:
                    </span>
                    <span class="spreadsheet-header-filter-info_gray">
                        {{ pagesInfo.total }} сделок на сумму {{ pagesInfo.amount }} р.
                    </span>
                </el-col>
            </el-row>
        </el-col>
        <el-col :span="2" justify="end" v-if="visibleOptions.isUnreadMessagesCountVisible">
            <div class="flex-row-2col">
                <div class="flex-column wrap-envelop"></div>
                <div class="flex-column wrap-unread-msg">
                    {{ pagesInfo.unread }}
                </div>
            </div>
        </el-col>
        <el-col :span="2" v-if="visibleOptions.isFilterVisible">
            <el-popover
                popper-class="grid-search-dialog"
                placement="top"
                width="293"
                trigger="click"
                v-model="isFilterFormVisible"
            >
                <el-button slot="reference" class="spreadsheet-header-button" type="warning">
                    поиск
                </el-button>
                <el-form label-position="top" class="deal-filter-main" @keyup.enter.native="filterApplied">
                    <el-form-item :label="fieldsNames.id" :label-width="formLabelWidth" v-if="isColumnVisible('id')">
                        <el-input v-model="filterModel.id" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.created_at" :label-width="formLabelWidth" v-if="isColumnVisible('created_at')">
                        <el-date-picker
                            v-model="filterModel.created_at"
                            type="daterange"
                            range-separator="по"
                            start-placeholder="дата"
                            end-placeholder="дата"
                            clearable
                            format="dd.MM.yyyy"
                            value-format="dd.MM.yyyy"
                            :picker-options="pickerOptions"
                            size="mini"
                            class="w100"
                        />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.tags" :label-width="formLabelWidth" v-if="isColumnVisible('tags')">
                        <el-select
                            v-model="filterModel.tags"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.tags"
                            size="mini"
                        >
                            <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.status_id" :label-width="formLabelWidth" v-if="isColumnVisible('status')">
                        <el-select
                            v-model="filterModel.status_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.status_id"
                            size="mini"
                        >
                            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.link_id" :label-width="formLabelWidth" v-if="isColumnVisible('link')">
                        <el-select
                            v-model="filterModel.link_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.link_id"
                            size="mini"
                        >
                            <el-option v-for="item in linkList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.office_id" :label-width="formLabelWidth" v-if="isColumnVisible('office')">
                        <el-select
                            v-model="filterModel.office_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.office_id"
                            size="mini"
                        >
                            <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.responsible_user_id" :label-width="formLabelWidth" v-if="isColumnVisible('responsible_user')">
                        <el-select
                            v-model="filterModel.responsible_user_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.responsible_user_id"
                            size="mini"
                        >
                            <el-option v-for="item in responsibleList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contact_id" :label-width="formLabelWidth" v-if="isColumnVisible('contact_name')">
                        <el-input v-model="filterModel.contact_name" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contact_phone" :label-width="formLabelWidth" v-if="isColumnVisible('contact_phone')">
                        <el-input v-model="filterModel.contact_phone" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contact_email" :label-width="formLabelWidth" v-if="isColumnVisible('contact_email')">
                        <el-input v-model="filterModel.contact_email" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.address" :label-width="formLabelWidth" v-if="isColumnVisible('address')">
                        <el-input v-model="filterModel.address" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.title" :label-width="formLabelWidth" v-if="isColumnVisible('title')">
                        <el-input v-model="filterModel.title" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.budget" :label-width="formLabelWidth" v-if="isColumnVisible('budget')">
                        <el-input v-model="filterModel.budget" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.volume" :label-width="formLabelWidth" v-if="isColumnVisible('volume')">
                        <el-input v-model="filterModel.volume" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.square_m2" :label-width="formLabelWidth" v-if="isColumnVisible('square_m2')">
                        <el-input v-model="filterModel.square_m2" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.profile_type_id" :label-width="formLabelWidth" v-if="isColumnVisible('profile_type')">
                        <el-select
                            v-model="filterModel.profile_type_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.profile_type_id"
                            size="mini"
                        >
                            <el-option v-for="item in profileTypes" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.finish" :label-width="formLabelWidth" v-if="isColumnVisible('finish')">
                        <el-checkbox v-model="filterModel.finish">
                            {{ fieldsNames.finish.toLocaleUpperCase() }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.finish_amount" :label-width="formLabelWidth" v-if="isColumnVisible('finish_amount')">
                        <el-input v-model="filterModel.finish_amount" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.jalousie" :label-width="formLabelWidth" v-if="isColumnVisible('jalousie')">
                        <el-checkbox v-model="filterModel.jalousie">
                            {{ fieldsNames.jalousie.toLocaleUpperCase() }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.jalousie_amount" :label-width="formLabelWidth" v-if="isColumnVisible('jalousie_amount')">
                        <el-input v-model="filterModel.jalousie_amount" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.promising_customer" :label-width="formLabelWidth" v-if="isColumnVisible('promising_customer')">
                        <el-checkbox v-model="filterModel.promising_customer">
                            {{ fieldsNames.promising_customer.toLocaleUpperCase() }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.to_production" :label-width="formLabelWidth" v-if="isColumnVisible('to_production')">
                        <el-checkbox v-model="filterModel.to_production">
                            {{ fieldsNames.to_production.toLocaleUpperCase() }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.measurement_date" :label-width="formLabelWidth" v-if="isColumnVisible('measurement_date')">
                        <el-date-picker
                            v-model="filterModel.measurement_date"
                            type="daterange"
                            range-separator="по"
                            start-placeholder="дата"
                            end-placeholder="дата"
                            clearable
                            format="dd.MM.yyyy"
                            value-format="dd.MM.yyyy"
                            :picker-options="pickerOptions"
                            size="mini"
                            class="w100"
                        />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.measurement_time" :label-width="formLabelWidth" v-if="isColumnVisible('measurement_time')">
                        <el-select
                            v-model="filterModel.measurement_time"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            autocomplete
                            clearable
                            placeholder=""
                            size="mini"
                        >
                            <el-option v-for="item in measurementTimeList" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.measurer_user_id" :label-width="formLabelWidth" v-if="isColumnVisible('measurer_user')">
                        <el-select
                            v-model="filterModel.measurer_user_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.measurer_user_id"
                            size="mini"
                        >
                            <el-option v-for="item in measurerList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.difficult_metering" :label-width="formLabelWidth" v-if="isColumnVisible('difficult_metering')">
                        <el-checkbox v-model="filterModel.difficult_metering">
                            {{ fieldsNames.difficult_metering.toLocaleUpperCase() }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.difficult_metering" :label-width="formLabelWidth" v-if="isColumnVisible('refuse_before_metering')">
                        <el-checkbox v-model="filterModel.refuse_before_metering">
                            {{ fieldsNames.refuse_before_metering.toLocaleUpperCase() }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.difficult_metering" :label-width="formLabelWidth" v-if="isColumnVisible('tech_refusal')">
                        <el-checkbox v-model="filterModel.tech_refusal">
                            {{ fieldsNames.tech_refusal.toLocaleUpperCase() }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.difficult_metering" :label-width="formLabelWidth" v-if="isColumnVisible('re_measurement')">
                        <el-checkbox v-model="filterModel.re_measurement">
                            {{ fieldsNames.re_measurement.toLocaleUpperCase() }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.re_measurement_date" :label-width="formLabelWidth" v-if="isColumnVisible('re_measurement_date')">
                        <el-date-picker
                            v-model="filterModel.re_measurement_date"
                            type="daterange"
                            range-separator="по"
                            start-placeholder="дата"
                            end-placeholder="дата"
                            clearable
                            format="dd.MM.yyyy"
                            value-format="dd.MM.yyyy"
                            :picker-options="pickerOptions"
                            size="mini"
                            class="w100"
                        />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.re_measurement_time" :label-width="formLabelWidth" v-if="isColumnVisible('re_measurement_time')">
                        <el-select
                            v-model="filterModel.re_measurement_time"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            autocomplete
                            clearable
                            placeholder=""
                            size="mini"
                        >
                            <el-option v-for="item in measurementTimeList" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.measurer_bonus" :label-width="formLabelWidth" v-if="isColumnVisible('measurer_bonus')">
                        <el-input v-model="filterModel.measurer_bonus" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contract_number" :label-width="formLabelWidth" v-if="isColumnVisible('contract_number')">
                        <el-input v-model="filterModel.contract_number" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.contract_date" :label-width="formLabelWidth" v-if="isColumnVisible('contract_date')">
                        <el-date-picker
                            v-model="filterModel.contract_date"
                            type="daterange"
                            range-separator="по"
                            start-placeholder="дата"
                            end-placeholder="дата"
                            clearable
                            format="dd.MM.yyyy"
                            value-format="dd.MM.yyyy"
                            :picker-options="pickerOptions"
                            size="mini"
                            class="w100"
                        />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.conclusion_id" :label-width="formLabelWidth" v-if="isColumnVisible('conclusion')">
                        <el-select
                            v-model="filterModel.conclusion_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            clearable
                            :placeholder="fieldsNames.conclusion_id"
                            size="mini"
                        >
                            <el-option v-for="item in conclusionTypes" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.start_production_date" :label-width="formLabelWidth" v-if="isColumnVisible('start_production_date')">
                        <el-date-picker
                            v-model="filterModel.start_production_date"
                            type="daterange"
                            range-separator="по"
                            start-placeholder="дата"
                            end-placeholder="дата"
                            clearable
                            format="dd.MM.yyyy"
                            value-format="dd.MM.yyyy"
                            :picker-options="pickerOptions"
                            size="mini"
                            class="w100"
                        />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.discount" :label-width="formLabelWidth" v-if="isColumnVisible('discount')">
                        <el-input v-model="filterModel.discount" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.pay_type_id" :label-width="formLabelWidth" v-if="isColumnVisible('pay_type')">
                        <el-select
                            v-model="filterModel.pay_type_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.pay_type_id"
                            size="mini"
                        >
                            <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.delivery_payment_plan" :label-width="formLabelWidth" v-if="isColumnVisible('delivery_payment_plan')">
                        <el-input v-model="filterModel.delivery_payment_plan" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.delivery_balance" :label-width="formLabelWidth" v-if="isColumnVisible('delivery_balance')">
                        <el-input v-model="filterModel.delivery_balance" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.installer_balance" :label-width="formLabelWidth" v-if="isColumnVisible('installer_balance')">
                        <el-input v-model="filterModel.installer_balance" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.garbage_removal_id" :label-width="formLabelWidth" v-if="isColumnVisible('garbage_removal')">
                        <el-select
                            v-model="filterModel.garbage_removal_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.garbage_removal_id"
                            size="mini"
                        >
                            <el-option v-for="item in garbageRemovalTypes" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.production_cost" :label-width="formLabelWidth" v-if="isColumnVisible('production_cost')">
                        <el-input v-model="filterModel.production_cost" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.in_production_id" :label-width="formLabelWidth" v-if="isColumnVisible('in_production')">
                        <el-select
                            v-model="filterModel.in_production_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            multiple
                            collapse-tags
                            clearable
                            :placeholder="fieldsNames.in_production_id"
                            size="mini"
                        >
                            <el-option v-for="item in factoriesList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.jalousie_cost" :label-width="formLabelWidth" v-if="isColumnVisible('jalousie_cost')">
                        <el-input v-model="filterModel.jalousie_cost" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.finish_cost" :label-width="formLabelWidth" v-if="isColumnVisible('finish_cost')">
                        <el-input v-model="filterModel.finish_cost" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.delivery_date" :label-width="formLabelWidth" v-if="isColumnVisible('delivery_date')">
                        <el-date-picker
                            v-model="filterModel.delivery_date"
                            type="daterange"
                            range-separator="по"
                            start-placeholder="дата"
                            end-placeholder="дата"
                            clearable
                            format="dd.MM.yyyy"
                            value-format="dd.MM.yyyy"
                            :picker-options="pickerOptions"
                            size="mini"
                            class="w100"
                        />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.installation_date" :label-width="formLabelWidth" v-if="isColumnVisible('installation_date')">
                        <el-date-picker
                            v-model="filterModel.installation_date"
                            type="daterange"
                            range-separator="по"
                            start-placeholder="дата"
                            end-placeholder="дата"
                            clearable
                            format="dd.MM.yyyy"
                            value-format="dd.MM.yyyy"
                            :picker-options="pickerOptions"
                            size="mini"
                            class="w100"
                        />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.installation_user_id" :label-width="formLabelWidth" v-if="isColumnVisible('installation_user')">
                        <el-select
                            v-model="filterModel.installation_user_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.installation_user_id"
                            size="mini"
                        >
                            <el-option v-for="item in installerList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.installers_salary" :label-width="formLabelWidth" v-if="isColumnVisible('installers_salary')">
                        <el-input v-model="filterModel.installers_salary" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.additional_work" :label-width="formLabelWidth" v-if="isColumnVisible('additional_work')">
                        <el-input v-model="filterModel.additional_work" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.installation_done" :label-width="formLabelWidth" v-if="isColumnVisible('installation_done')">
                        <el-checkbox v-model="filterModel.installation_done">
                            {{ fieldsNames.installation_done.toLocaleUpperCase() }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.complaint_opening_date" :label-width="formLabelWidth" v-if="isColumnVisible('complaint_opening_date')">
                        <el-date-picker
                            v-model="filterModel.complaint_opening_date"
                            type="daterange"
                            range-separator="по"
                            start-placeholder="дата"
                            end-placeholder="дата"
                            clearable
                            format="dd.MM.yyyy"
                            value-format="dd.MM.yyyy"
                            :picker-options="pickerOptions"
                            size="mini"
                            class="w100"
                        />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.complaint_amount" :label-width="formLabelWidth" v-if="isColumnVisible('complaint_amount')">
                        <el-input v-model="filterModel.complaint_amount" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.guilty_id" :label-width="formLabelWidth" v-if="isColumnVisible('guilty')">
                        <el-select
                            v-model="filterModel.guilty_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            clearable
                            :placeholder="fieldsNames.guilty_id"
                            size="mini"
                            @change="handleChangeGuilty"
                        >
                            <el-option v-for="item in guiltyTypes" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.culprit_id" :label-width="formLabelWidth" v-if="isColumnVisible('culprit')">
                        <el-select
                            v-model="filterModel.culprit_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.culprit_id"
                            size="mini"
                        >
                            <el-option v-for="item in culpritList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.complaint_performer_id" :label-width="formLabelWidth" v-if="isColumnVisible('complaint_performer')">
                        <el-select
                            v-model="filterModel.complaint_performer_id"
                            placement="bottom"
                            popper-class="popper-dropdown"
                            filterable
                            multiple
                            collapse-tags
                            clearable
                            autocomplete
                            :placeholder="fieldsNames.complaint_performer_id"
                            size="mini"
                        >
                            <el-option-group
                                v-for="group in complaintPerformerList"
                                :key="group.label"
                                :label="group.label"
                            >
                                <el-option
                                    v-for="item in group.options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="`${group.type}_${item.id}`"
                                />
                            </el-option-group>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="fieldsNames.specialist_payment" :label-width="formLabelWidth" v-if="isColumnVisible('specialist_payment')">
                        <el-input v-model="filterModel.specialist_payment" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.complaint_materials_cost" :label-width="formLabelWidth" v-if="isColumnVisible('complaint_materials_cost')">
                        <el-input v-model="filterModel.complaint_materials_cost" autocomplete="on" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.complaint_closing_date" :label-width="formLabelWidth" v-if="isColumnVisible('complaint_closing_date')">
                        <el-date-picker
                            v-model="filterModel.complaint_closing_date"
                            type="daterange"
                            range-separator="по"
                            start-placeholder="дата"
                            end-placeholder="дата"
                            clearable
                            format="dd.MM.yyyy"
                            value-format="dd.MM.yyyy"
                            :picker-options="pickerOptions"
                            size="mini"
                            class="w100"
                        />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.custom_fields" :label-width="formLabelWidth" v-if="isColumnVisible('custom_fields')">
                        <el-input v-model="filterModel.customFields" autocomplete="off" size="mini" clearable />
                    </el-form-item>
                    <el-form-item :label="fieldsNames.unread_messages" :label-width="formLabelWidth" v-if="isColumnVisible('unread_messages')">
                        <el-checkbox v-model="filterModel.unread_messages">
                            {{ fieldsNames.unread_messages.toLocaleUpperCase() }}
                        </el-checkbox>
                    </el-form-item>
                </el-form>
                <div class="popover-footer">
                    <el-button @click="hideFilterForm">
                        Отменить
                    </el-button>
                    <el-button type="warning" @click="filterApplied">
                        Применить
                    </el-button>
                </div>
            </el-popover>
        </el-col>
        <el-col :span="3">
            <span class="spreadsheet-header-total">
                Всего записей: {{ pagesInfo.total }}
            </span>
        </el-col>
        <el-col :span="3" v-if="visibleOptions.isNewButtonVisible">
            <el-button class="spreadsheet-header-button" type="warning" @click="goNewCard">
                новая сделка
            </el-button>
        </el-col>
        <el-col :span="3" v-if="visibleOptions.isGoBackButtonVisible">
            <el-button class="spreadsheet-header-button" type="warning" @click="goBack">
                Назад
            </el-button>
        </el-col>
        <el-col :span="1" title="Excel" class="icon-excel" v-if="isExcelButtonVisible">
            <div class="spreadsheet-header-excel" @click="handleExcelAction()">
                &nbsp;
            </div>
        </el-col>
    </el-row>
</template>

<script>
import { pickerOptions } from '@/common/pickerOptions';
import localReferences from '@/helpers/localReferences';

export default {
    name: 'GridHeader',
    data() {
        return {
            isFilterFormVisible: false,
            formLabelWidth: '120px',
            pickerOptions
        };
    },
    props: {
        title: {
            type: String,
            default: 'Список сделок'
        },
        filter: {
            type: Object,
            default: () => {}
        },
        fields: {
            type: Object,
            default: () => {}
        },
        gridOptions: {
            type: Object,
            default: () => {}
        },
        visibleOptions: {
            type: Object,
            default: () => {
                return {
                    isUnreadMessagesCountVisible: true,
                    isFilterVisible: true,
                    isNewButtonVisible: true,
                    isGoBackButtonVisible: true,
                    isExcelButtonVisible: true
                };
            }
        }
    },
    computed: {
        filterModel() {
            return this.filter;
        },
        fieldsNames() {
            return this.fields;
        },
        pagesInfo() {
            return this.$store.state.deals.pages;
        },
        tagList() {
            return this.$store.state.references.tags;
        },
        statusList() {
            return this.$store.state.references.dealStatuses;
        },
        linkList() {
            return this.$store.state.references.links;
        },
        officeList() {
            return this.$store.state.references.offices;
        },
        responsibleList() {
            return this.$store.state.references.employers;
        },
        measurerList() {
            return this.$store.state.references.measurers;
        },
        installerList() {
            return this.$store.state.references.installers;
        },
        payTypesList() {
            return this.$store.state.references.payTypes;
        },
        factoriesList() {
            return this.$store.state.references.factories;
        },
        profileTypes() {
            return this.$store.state.references.profileTypes;
        },
        conclusionTypes() {
            return this.$store.state.references.conclusions;
        },
        garbageRemovalTypes() {
            return this.$store.state.references.garbageRemovals;
        },
        guiltyTypes() {
            return this.$store.state.references.guilty;
        },
        measurementTimeList() {
            return this.$store.state.references.measurementTimes;
        },
        culpritList() {
            if (this.filterModel.guilty_id === localReferences.complaintGuilty.factory) {
                return this.factoriesList;
            }
            if (this.filterModel.guilty_id === localReferences.complaintGuilty.measurer) {
                return this.measurerList;
            }
            if (this.filterModel.guilty_id === localReferences.complaintGuilty.installer) {
                return this.installerList;
            }
            return this.responsibleList;
        },
        complaintPerformerList() {
            return [
                {
                    label: 'Сервис',
                    type: 'service',
                    options: this.$store.state.references.complaintPerformer
                },
                {
                    label: 'Производство',
                    type: 'factory',
                    options: this.$store.state.references.factories
                },
                {
                    label: 'Установщики',
                    type: 'installer',
                    options: this.$store.state.references.installers
                }
            ];
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'responsible_user_id':
                            case 'measurer_user_id':
                            case 'installation_user_id':
                                result += this.getNames(this.responsibleList, field);
                                break;
                            case 'status_id':
                                result += this.getNames(this.statusList, field);
                                break;
                            case 'link_id':
                                result += this.getNames(this.linkList, field);
                                break;
                            case 'tags':
                                result += this.getNames(this.tagList, field);
                                break;
                            case 'office_id':
                                result += this.getNames(this.officeList, field);
                                break;
                            case 'pay_type_id':
                                result += this.getNames(this.payTypesList, field);
                                break;
                            case 'profile_type_id':
                                result += this.getNames(this.profileTypes, field);
                                break;
                            case 'in_production_id':
                                result += this.getNames(this.factoriesList, field);
                                break;
                            case 'garbage_removal_id':
                                result += this.getNames(this.garbageRemovalTypes, field);
                                break;
                            case 'complaint_performer_id':
                                result += this.getNamesFromCombinedList(this.complaintPerformerList, field);
                                break;
                            case 'culprit_id':
                                result += this.getNames(this.culpritList, field);
                                break;
                            case 'created_at':
                            case 'contract_date':
                            case 'measurement_date':
                            case 'start_production_date':
                            case 'delivery_date':
                            case 'installation_date':
                            case 'complaint_opening_date':
                            case 'complaint_closing_date':
                                result += `${this.fieldsNames[field]}: c ${this.filterModel[field][0]}
                                 по ${this.filterModel[field][1]}; `;
                                break;
                            default:
                                result += `${this.fieldsNames[field]}: ${this.filterModel[field]}; `;
                        }
                    }
                    if (typeof this.filterModel[field] === 'number') {
                        switch (field) {
                            case 'conclusion_id':
                                result += this.getOneName(this.conclusionTypes, field);
                                break;
                            case 'guilty_id':
                                result += this.getOneName(this.guiltyTypes, field);
                                break;
                        }
                    }
                }
            }
            return result;
        },
        isExcelButtonVisible() {
            return this.visibleOptions.isExcelButtonVisible && this.$store.getters.isCanDealExportExcel;
        }
    },
    methods: {
        filterApplied() {
            this.isFilterFormVisible = false;
            this.$emit('filterApplied', this.filterModel);
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        goNewCard() {
            this.$router.push({ name: 'deal-card-new' });
        },
        getNames(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]} : ${this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ')}; `;
            }
            return '';
        },
        getNamesFromCombinedList(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]} : ${this.filterModel[field].map(combinedValue => {
                    const type = combinedValue.split('_')[0];
                    const id = +combinedValue.split('_')[1];
                    const record = obj.find(item => item.type === type).options.find(item => item.id === id);
                    return record ? record.name : '';
                }).join(' | ')}; `;
            }
            return '';
        },
        getOneName(obj, field) {
            if (Object.keys(obj).length !== 0) {
                return `${this.fieldsNames[field]} : ${obj.filter(item => item.id === this.filterModel[field]).map(item => item.name).join('')}; `;
            }
            return '';
        },
        handleChangeGuilty(value) {
            if (value) {
                this.filterModel.complaint_performer_id = [];
                this.filterModel.culprit_id = [];
            }
        },
        isColumnVisible(colId) {
            if (this.isFilterFormVisible && this.gridOptions.columnApi) {
                const column = this.gridOptions.columnApi.getColumn(colId);
                return column && column.visible;
            }
            return false;
        },
        goBack() {
            this.$router.go(-1);
        },
        handleExcelAction() {
            if (+this.pagesInfo.total > 15000) {
                this.$message({
                    showClose: true,
                    message: 'Можно выгрузить не более 15 000 сделок',
                    type: 'error',
                    duration: 5000,
                    customClass: this.alertClass()
                });
            } else {
                this.$emit('excelAction');
            }
        }
    }
};
</script>
